export default __webpack_public_path__ + "static/media/profile.60bbb126.jpg";